<template>
    <div class="imagecontainer">
        <button class="pager-arrow prev" href="#" @click.prevent="active--" :disabled="active <= 0">◀</button>
        <button class="pager-arrow next" href="#" @click.prevent="active++" :disabled="active >= photos.length - 1">▶</button>
        <a v-for="(photo, index) in photos" v-show="active === index" :href="photo.image" data-fancybox="gallery" class="carousel-top-image" :style="{ backgroundImage: 'url(' + photo.image + ')' }" :key="index"></a>

        <carousel :perPage="5" :navigationEnabled="true" :paginationEnabled="false" :navigationClickTargetSize="3">
            <slide v-for="(photo, index) in photos" :key="index">
                <a href="#" class="slide" @click.prevent="active = index">
                    <div class="imageholder" :style="{ backgroundImage: 'url(' + photo.image + ')' }"></div>
                </a>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        data () {
            return {
                active: 0,
                photos: this.$root.images,
            }
        },
        components: {
            Carousel,
            Slide,
        },
    }
</script>
